import type { WaterSolutionGasRswCalculator } from "../d";
export const waterSolutionGasRswCalculator: WaterSolutionGasRswCalculator =
  params => {
    const { temperatureF, inSituPressurePSIA, salinity_ppm } = params;

    const A = calculateA(temperatureF);
    const B = calculateB(temperatureF);
    const C = calculateC(temperatureF);

    const pureWaterSolutionGas = calculatePureWaterSolutionGas(
      A,
      B,
      C,
      inSituPressurePSIA
    );

    const salinityCorrection = calculateSalinityCorrection(
      salinity_ppm,
      temperatureF
    );

    const waterPhaseGasSolubilitySCFSTB = calculateWaterSolutionGas(
      pureWaterSolutionGas,
      salinityCorrection
    );

    return {
      waterPhaseGasSolubilitySCFSTB,
      A,
      B,
      C,
      pureWaterSolutionGas,
      salinityCorrection
    };
  };

// H28: =8.15839-6.12265*(10^-2)*C3+1.91663*(10^-4)*C3^2-2.1654*(10^-7)*C3^3
function calculateA(temperatureF: number): number {
  return (
    8.15839 -
    6.12265 * Math.pow(10, -2) * temperatureF +
    1.91663 * Math.pow(10, -4) * Math.pow(temperatureF, 2) -
    2.1654 * Math.pow(10, -7) * Math.pow(temperatureF, 3)
  );
}

// H29: =1.01021*(10^-2)-7.44241*(10^-5)*C3+3.05553*(10^-7)*C3^2-2.94883*(10^-10)*C3^3
function calculateB(temperatureF: number): number {
  return (
    1.01021 * Math.pow(10, -2) -
    7.44241 * Math.pow(10, -5) * temperatureF +
    3.05553 * Math.pow(10, -7) * Math.pow(temperatureF, 2) -
    2.94883 * Math.pow(10, -10) * Math.pow(temperatureF, 3)
  );
}

// H30: =-(10^-7)*(9.02505-0.130237*C3+8.53425*(10^-4)*C3^2-2.34122*(10^-6)*C3^3+2.37049*(10^-9)*C3^4)
function calculateC(temperatureF: number): number {
  return (
    -Math.pow(10, -7) *
    (9.02505 -
      0.130237 * temperatureF +
      8.53425 * Math.pow(10, -4) * Math.pow(temperatureF, 2) -
      2.34122 * Math.pow(10, -6) * Math.pow(temperatureF, 3) +
      2.37049 * Math.pow(10, -9) * Math.pow(temperatureF, 4))
  );
}

// H32: =H28+H29*C2+H30*C2^2
function calculatePureWaterSolutionGas(
  A: number,
  B: number,
  C: number,
  inSituPressurePSIA: number
): number {
  return A + B * inSituPressurePSIA + C * Math.pow(inSituPressurePSIA, 2);
}

// H34: =0.0840655*(C7/1000000)*C3^(-0.285854)
function calculateSalinityCorrection(
  salinity_ppm: number,
  temperatureF: number
): number {
  return (
    0.0840655 * (salinity_ppm / 1000000) * Math.pow(temperatureF, -0.285854)
  );
}

// H36: =H32*10^-H34
function calculateWaterSolutionGas(
  pureWaterSolutionGas: number,
  salinityCorrection: number
): number {
  return pureWaterSolutionGas * Math.pow(10, -salinityCorrection);
}
